<script>
  export let max_work_num;
  export let workHeaderWidth;
  export let startDragS;
  export let tableData;
  export let get_work_row_block_right_content;
  export let scrollableTableWidth;
  export let handleScroll;
  export let tableHeight;
  export let preprocessTableData;

  function syncScroll(event) {
    const scrollableTableHeader = document.querySelector('.scrollable-table-header');
    scrollableTableHeader.scrollLeft = event.target.scrollLeft;
  }

  function syncScrollF(event) {
    const fixedTableContainer = document.querySelector('.fixed-table-container');
    fixedTableContainer.scrollTop = event.target.scrollTop;
  }


  $: preprocessedData = preprocessTableData(tableData);
</script>

<div class="scrollable-table-container" style="height: {tableHeight}px;" on:scroll={syncScrollF} on:mousedown={startDragS}>
  <div class="scrollable-table-header horizontal-scroll" id="scrollable-table-header" style="width: {scrollableTableWidth}px; z-index: 15;" on:wheel={handleScroll}>
    <table style="min-width: {workHeaderWidth * max_work_num}px">
      <thead>
        <tr>
          {#each Array(max_work_num) as _, i}
            <th id="th_s_{i}" class="work-header" style="width: {workHeaderWidth}px;" >
              <div class="work-header-container">
                <div class="top" >{i + 1}</div>
                <div class="bot" >
                  <div class="bot-part bot-left">工程</div>
                  <div class="bot-part bot-right">開始</div>
                </div>
              </div>
              <div id="resizer_s_{i}" class="resizer" style="z-index: 20;"></div>
            </th>
          {/each}
        </tr>
      </thead>
    </table>
  </div>
  <div class="scrollable-table-body horizontal-scroll" id="scrollable-table-body" style="width: {scrollableTableWidth}px;" on:scroll={syncScroll} on:wheel={handleScroll}>
    <table style="min-width: {workHeaderWidth * max_work_num}px">
      <tbody>
        {#each preprocessedData as row}
          <tr>
            {#each Array(max_work_num) as _, i }
              {#if i < row.Works.length}
                <td class="work-row" style="width: {workHeaderWidth}px; height: 45px; ">
                  <div class="work-row-block-container {row.Works[i].__className}">
                    <div class="work-row-block left">{row.Works[i].Work_OperationProcName}</div>
                    <div class="work-row-block right">{get_work_row_block_right_content(row.Works[i])}</div>
                  </div>
                  <div id="resizer_s_{i}" class="resizer" style="z-index: 10;"></div>
                </td>
              {:else}
                <td class="work-row">
                  <div id="resizer_s_{i}" class="resizer" style="z-index: 10;"></div>
                </td>
              {/if}
            {/each}
          </tr>
        {/each}
      </tbody>
    </table>
  </div>
</div>

<style>
  .scrollable-table-container{
    height: 1000px;
    overflow-x: auto;
    overflow-y: auto;
  }
  .scrollable-table-header {
    position: sticky;
    top: 0;
    z-index: 3;
    background-color: #E6E6E6;
    /* overflow-x: hidden; */
  }

  .scrollable-table-header table th {
    height: 60px;
  }

  .scrollable-table-body{
    flex-grow: 1;
    /* overflow-x: hidden; */
  }

  table {
    table-layout: fixed;
    border-collapse: collapse;
  }

  th, td {
    /* padding: 8px; */
    text-align: center;
    border: 1px solid #BBBBBB;
    background-color: #fff;
    font-size: 10px;
    line-height: 1.2;
  }

  th {
    padding: 0 !important;

    height: auto;
  }

  td {
    padding: 8px;
    box-sizing: border-box;
  }

  table tr:first-child td {
    border-top: none;
  }

  .date-part, .time-part {
    display: block;
  }

  @media (min-width: 400px) {
    .date-part, .time-part {
      display: inline;
    }
  }

  /* for header */
  .work-header {
    background-color: #E6E6E6;
    position: relative;
  }

  /* new */
  .work-header-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
  }

  .top {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    border-bottom: 1px solid #BBBBBB;
    background-color: #E6E6E6;

  }
  .bot {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    
    
  }

  .bot-part {
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #E6E6E6;
  }

  .bot-left {
    border-right: 1px solid #BBBBBB;
  }

  /* for row */
  .work-row {
    position: relative;
    padding-left: 0;
    padding-right: 0;
    box-sizing: border-box;
  }

  .work-row-block-container {
    display: flex;
    height: 100%;
    align-items: center;
    justify-items: center;
  }

  .work-row .work-row-block {
    display: flex;
    align-items: center;
    justify-content: center;
  }

/*   .work-row .left {
    grid-row: 1 / 1;
    grid-column: 1 / 2;
    width: 100%;
    height: 100%;
  }

  .work-row .right {
    grid-row: 1 / 1;
    grid-column: 2 / 3;
    width: 100%;
    height: 100%;
  } */

  .work-row-block {
    width: 100%;
    height: 100%;
  }
  .search-hitted .work-row-block.left {
    background-color: #8DC2F9;
  }
  .completed {
    background-color: #DBDCE3;
  }

  .in-progress {
    background-color: #F9F666;
  }

  .page-selector-container {
    margin-left: auto;
  }

  .resizer {
    position: absolute;
    top: 0;
    right: -3px;
    width: 6px;
    height: 100%;
    cursor: ew-resize;
    background-color: transparent;
  }

</style>